import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'mdate',
})
export class MDatePipe implements PipeTransform {
  transform(value: any, format = 'YYYY-MM-DD'): any {
    if (value) {
      return moment(value).format(format);
    }
    return '';
  }
}
